<admin-header [primaryButtons]="headerPrimaryButtons" [secondaryButtons]="headerSecondaryButtons"
	[tertiaryButtons]="headerTertiaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div *ngIf="isLoading" class="overlay">
	<div class="spinner"></div>
</div>
<div class="row" id="filters">
	<div class="col-12">
		<dx-button (onClick)="viewToday()" style="float: right !important;"><i class="fal fa-calendar-check"></i>
			Today</dx-button>
		<dx-date-box [value]="opsPlanningDate" label="Date" id="opsPlanningDate" stylingMode="filled" labelMode="hidden"
			displayFormat="dd/MM/yyyy" [min]="minDate" (onValueChanged)="changeOpsPlanningDate($event)"
			style="float: right !important; width: 200px;"></dx-date-box>
		<dx-select-box [value]="opsPlanningMode" id="opsPlanningMode" [dataSource]="opsPlanningModes" displayExpr="name"
			placeholder="Mode" valueExpr="id" [showClearButton]="false" (onValueChanged)="changeOpsPlanningMode($event)"
			style="float: right !important; width: 200px;"></dx-select-box>
	</div>
</div>
<div class="row" style="padding-left:20px; padding-right:20px;">
	<!-- <div *ngIf="machines.length === 0" id="loadingBar"><i class="fad fa-sync-alt fa-spin"></i> Loading...</div> -->

	<!-- machine-container.component.html -->
	<div class="machine-container">
		<div *ngFor="let machine of machines" class="machine-card">
			<div class="machine-header"
				[ngStyle]="{ 'background-color': this.renderStatusBackgroundColor(machine.productionStatus) }">
				<div class="header-left">
					<div class="status-indicator"
						[ngStyle]="{ 'background-color': this.renderStatusColor(machine.productionStatus) }"></div>
					<a href="/admin/machines/{{machine.machineId}}" style="text-decoration: none;">
						<h3>{{ machine.cellNumber }}</h3>
					</a>
				</div>
				<a *ngIf="machine.machineId > 0" href="#"
					(click)="changeMachineProductionStatusPopup(machine.machineId)"
					style=" text-decoration: none; padding-left:10px; padding-right:10px; border-radius:0.5rem"
					[ngStyle]="{ 'background-color': this.renderStatusButtonColor(machine.productionStatus), 'color': this.renderStatusButtonTextColor(machine.productionStatus) }">
					<span class="order-id" style="margin-right:5px; text-decoration: none;">{{
						machine.productionStatusName.toUpperCase() }}</span><i class="fas fa-chevron-down"></i></a>
			</div>



			<div class="machine-info"
				[ngStyle]="{ 'background-color': this.renderStatusBackgroundColor(machine.productionStatus) }">
				<span><i class="fa fa-tachometer-alt"></i> {{ machine.utilisation }} 100</span> |
				<span><i class="fa fa-clock"></i> {{ machine.load }}100</span> |
				<span><i class="fa fa-sun"></i> {{ machine.dayShiftDescription }}</span> |
				<span><i class="fa fa-moon"></i> {{ machine.nightShiftDescription }}</span> |
				<span><i class="fa fa-recycle"></i> {{ machine.scrappedParts }}</span>

			</div>
			<div class="machine-info"
				[ngStyle]="{ 'background-color': this.renderStatusBackgroundColor(machine.productionStatus) }"
				style="padding:0;">
				<div class="progress-bar" style="height:10px; margin: 0 0.75rem 0.75rem; border-radius:0.25rem"></div>
			</div>
			<!-- style="width:{{machine.runningStages[0].quantityCompleted/machine.runningStages[0].quantityRequired * 100}}%; -->

			<div class="in-progress" *ngIf="machine.runningStages.length > 0">
				<h4>In Progress</h4>
				<div *ngFor="let workOrderStage of machine.runningStages">
					<div class="work-order"
						[ngStyle]="{'background-color' : workOrderStage.isPaused === true ? '#FEF7ED' : '#EFF6FF' }">
						<div class="progress-bar-container">
							<div class="progress-bar"
								[style.width.%]="(workOrderStage.quantityCompleted/workOrderStage.quantityRequired * 100)">
							</div>
						</div>
						<div class="order-header">
							<a href="/admin/workOrders/{{workOrderStage.workOrderId}}"
								style="color: #3571ED; text-decoration: none;"><span class="order-id"
									style="color: #3571ED !important; background-color: #DBEAFE">{{ workOrderStage.id
									}}</span></a>
							<a href="/admin/parts/{{workOrderStage.partId}}"
								style="color: #3571ED !important; text-decoration: none;"><span class="part-number"
									style="color: #3571ED !important;">{{ workOrderStage.partNumber }}</span></a>
							<a style="color: #3571ED !important;"><span class="operation"
									style="color: #3571ED !important;">{{ workOrderStage.operationNumber }}</span></a>
						</div>
						<div class="order-info">
							<div class="col-8">
								<div class="row">
									<div class="operator" title="Operator">{{ workOrderStage.assignedUserProfileFullName === "" ? "No
										Operator" :
										workOrderStage.assignedUserProfileFullName }}</div>
								</div>
								<div class="row">
									<div class="col-6">

										<div title="Quantity Complete/Required"><strong>{{ workOrderStage.quantityCompleted }}/{{
												workOrderStage.quantityRequired
												}}</strong></div>

									</div>
									<div class="col-6">

										<div title="Scrapped Parts" *ngIf="workOrderStage.scrappedParts !== undefined">Scrap: <strong>{{
												workOrderStage.scrappedParts }}</strong>
										</div>

									</div>
								</div>
								<div class="row">
									<div class="col-6">

										<div title="Start and End Time">{{ workOrderStage.estimatedStartTimeDescription === "-" ? "N/A" :
											workOrderStage.estimatedStartTimeDescription }} - {{
											workOrderStage.estimatedStartTimeDescription === "-" ? "N/A" :
											workOrderStage.estimatedStartTimeDescription }}</div>

									</div>
									<div class="col-6">

										<div title="Start Date (Total Shifts)"><strong>{{ workOrderStage.estimatedStartDate }} ({{workOrderStage.estimatedShifts == 0 ? 1 : workOrderStage.estimatedShifts}})</strong></div>

									</div>
								</div>

							</div>
							<div class="col-4">
								<div id="availablePartNumber{{workOrderStage.id}}" class="image-wrapper"
									style="height:100%; width:100%;">
									<img style="max-height:50px; max-width:75px" *ngIf="workOrderStage.partImage"
										[src]="workOrderStage.partImage" alt="Part Image">
								</div>
							</div>
						</div>
						<div class="actions">
							<button title="Pause Work Order"><i class="fa fa-pause"></i></button>
							<button title="Move Machine" (click)="changeWorkOrderStageMachinePopup(workOrderStage.id)"><i
									class="fa fa-exchange-alt"></i></button>
							<button title="Change Operator" (click)="changeWorkOrderStageOperatorPopup(workOrderStage.id, machine.machineId,true)"><i
									class="fa fa-user"></i></button>
									<button title="Next Operator" (click)="assignNextOperatorInQueue(workOrderStage.id)"><i
									class="fa fa-user-check"></i></button>
							<button title="Recalculate Estimates" (click)="recalculateStageEstimates(workOrderStage.id)"><i
									class="fa fa-stopwatch"></i></button>
						</div>
						<dx-tooltip target="#availablePartNumber{{workOrderStage.id}}" showEvent="mouseenter"
							hideEvent="mouseleave" position="right" style="margin-left:50px;">
							<div *dxTemplate="let data = data; of: 'content'">
								<img alt="{{workOrderStage.partNumber}}" width="500"
									src="{{workOrderStage.partImage}}" />
							</div>
						</dx-tooltip>
					</div>
				</div>
			</div>

			<div class="queue">
				<h4>Queue</h4>
				<div *ngIf="machine.availableStages.length < 1">
					Nothing currently in the queue!
				</div>
				<div *ngIf="machine.availableStages.length > 0">
					<div
						*ngFor="let order of machinesShowingAllAvailable.indexOf(machine.machineId) >= 0 ? machine.availableStages : machine.availableStages.slice(0,2)">
						<div class="work-order"
							[ngStyle]="{ 'border-left': order.isPending === true ? 'solid red 5px' : 'solid orange 5px', 'background-color' : order.isPaused === true ? '#FEF7ED' : '#FFFFFF' }">
							<div *ngIf="order.isPaused" class="progress-bar-container-paused">
								<div class="progress-bar-paused"
									[style.width.%]="(order.quantityCompleted/order.quantityRequired * 100)"></div>
							</div>
							<div class="order-header">
								<a href="/admin/workOrders/{{order.workOrderId}}"><span class="order-id"
										[ngStyle]="{'background-color': order.isPaused ? '#FDEDD5' : '#F3F4F6', 'color': order.isPaused ? '#EA5A15' : '#4B5563'}">{{
										order.id }}</span></a>
								<a href="/admin/parts/{{order.partId}}"><span class="part-number"
										[ngStyle]="{'color': order.isPaused ? '#EA5A15' : '#4B5563'}">{{
										order.partNumber }}</span></a>
								<dx-select-box *ngIf="order.isPaused === false && order.desiredStartTime === null"
									[dataSource]="priorities" [value]="order.priority" [showClearButton]="false"
									(onValueChanged)="changeWorkOrderStagePriorityDropDown($event, order.id)"
									style="height:30px;font-size:10pt; width:100px;"></dx-select-box>
								<span *ngIf="order.isPaused === false && order.desiredStartTime !== null"
									class="operation">{{ order.priority }}</span>
								<span *ngIf="order.isPaused" class="operation"><i class="fa fa-pause"
										style="color: #EA5A15"></i></span>
							</div>

							<div class="order-info">
								<div class="col-8">
									<div class="row">
										<div class="operator" title="Operator"
											[ngStyle]="{'color': order.assignedUserProfileFullName === '' ? 'red' : '#111827'}">
											{{ order.assignedUserProfileFullName === "" ? "No Operator" :
											order.assignedUserProfileFullName }}</div>
									</div>
									<div class="row">
										<div class="col-6">

											<div title="Quantity Complete/Required"><strong>{{ order.quantityCompleted }}/{{ order.quantityRequired
													}}</strong></div>

										</div>
										<div class="col-6">

											<div title="Operation Number"><strong>{{
													order.operationNumber }}</strong>
											</div>

										</div>
									</div>
									<div class="row">
										<div class="col-6">

											<div title="Start and End Time">{{ order.estimatedStartTimeDescription === "-" ? "N/A" :
												order.estimatedStartTimeDescription }} - {{
												order.estimatedStartTimeDescription === "-" ? "N/A" :
												order.estimatedStartTimeDescription }}</div>

										</div>
										<div class="col-6">

											<div title="Start Date (Total Shifts)"><strong>{{ order.estimatedStartDate }}  ({{order.estimatedShifts == 0 ? '1' : order.estimatedShifts}})</strong></div>

										</div>
									</div>

								</div>
								<div class="col-4">
									<div id="availablePartNumber{{order.id}}" class="image-wrapper"
										style="height:100%; width:100%;">
										<img style="max-height:50px; max-width:75px" *ngIf="order.partImage"
											[src]="order.partImage" alt="Part Image">
									</div>
								</div>

							</div>

							<div class="actions">
								<button title="Resume Work Order" *ngIf="order.isPaused"><i class="fa fa-play"></i></button>
								<button title="Move Machine" (click)="changeWorkOrderStageMachinePopup(order.id)"><i
										class="fa fa-exchange-alt"></i></button>
								<button title="Change Operators" (click)="changeWorkOrderStageOperatorPopup(order.id, machine.machineId,false)"><i
										class="fa fa-user"></i></button>
								<button title="Change Date" (click)="changeWorkOrderStageEstimatedStartDatePopup(order.id)"><i
										class="fa fa-calendar"></i></button>
								<button title="Change Start Time" (click)="changeWorkOrderStageDesiredStartTimePopup(order.id)"><i
										class="fa fa-clock"></i></button>
							</div>
							<dx-tooltip target="#availablePartNumber{{order.id}}" showEvent="mouseenter"
								hideEvent="mouseleave" position="right" style="margin-left:50px !important;">
								<div *dxTemplate="let data = data; of: 'content'">
									<img alt="{{order.partNumber}}" width="500" src="{{order.partImage}}" />
								</div>
							</dx-tooltip>
						</div>
					</div>

				</div>

			</div>

			<div class="expand-control" *ngIf="machine.availableStages.length + machine.runningStages.length >= 3"
				(click)="toggleMachineShowingAllAvailable(machine.machineId)">
				<i
					class="{{machinesShowingAllAvailable.indexOf(machine.machineId) >= 0 ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}}"></i>
			</div>
		</div>
	</div>
</div>
<dx-popup width="80%" [height]="500" [showTitle]="true" [title]="popupTitle" [dragEnabled]="false"
	[closeOnOutsideClick]="false" [showCloseButton]="false" container=".dx-viewport" [(visible)]="popupVisible">
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="before"
		[options]="popupAddButtonOptions"></dxi-toolbar-item>
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after"
		[options]="popupCloseButtonOptions"></dxi-toolbar-item>
	<dx-form *ngIf="popupTitle === 'Change Desired Start Time'" class="m-3"
		[(formData)]="popupChangeWorkOrderStageDesiredStartTime" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item>
			<p>You must enter a valid time in HH:mm format, e.g. 09:30.</p>
		</dxi-item>
		<dxi-item dataField="startTime"></dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Estimated Start Date'" class="m-3"
		[(formData)]="popupChangeWorkOrderStageEstimatedStartDate" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item>
			<p>Please note that this will revert if the estimates on this work order are recalculated.</p>
			<p>Future stages of this work order will also be changed relative to this.</p>
		</dxi-item>
		<dxi-item dataField="estimatedStartDate" editorType="dxDateBox"
			[editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }"></dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Machine'" class="m-3" [(formData)]="popupChangeWorkOrderStageMachine"
		[showColonAfterLabel]="true" labelLocation="top">
		<dxi-item dataField="machineId" editorType="dxSelectBox"
			[editorOptions]="{ items: machines, searchEnabled: true, displayExpr: displayMachineInDropdown, valueExpr:'machineId' }"
			[label]="{ text: 'Machine' }"></dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Operators'" class="m-3" [(formData)]="popupChangeWorkOrderStageOperator" [showColonAfterLabel]="true" labelLocation="top" [colCount]="2">
		<dxi-item dataField="userProfileId" editorType="dxSelectBox" [editorOptions]="{ items: dropdownUserProfiles, searchEnabled: true, displayExpr: displayUserProfileInDropdown, valueExpr:'id' }" [label]="{ text: 'Operator' }"></dxi-item>
		<dxi-item><p>Estimated Shifts: {{popupEstimatedShifts}}</p></dxi-item>
		<dxi-item itemType="group" [colSpan]="2">
			<dx-data-grid class="data-grid" [dataSource]="popupOperatorQueue" [remoteOperations]="false" [allowColumnReordering]="false" [allowColumnResizing]="false" [rowAlternationEnabled]="true" [showBorders]="true" height="200px">
				<dxo-paging [pageSize]="100"></dxo-paging>
				<dxo-pager [visible]="false" [showPageSizeSelector]="false" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
				<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
				<dxo-group-panel [visible]="false"></dxo-group-panel>
				<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
				<dxo-export [enabled]="false"></dxo-export>
				<dxo-row-dragging [allowReordering]="true" [onReorder]="updatePopupOperatorQueueOrder" [showDragIcons]="true"></dxo-row-dragging>
				<dxo-editing mode="popup" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true" [confirmDelete]="true" [useIcons]="true" newRowPosition="last" [changes]="changes" [(editRowKey)]="editRowKey">
				<dxo-popup title="Select Operator" [showTitle]="true" [width]="'50%'" [height]="'auto'"></dxo-popup>
				<dxo-form [colCount]="1">
					<dxi-item dataField="operatorId" editorType="dxSelectBox" [editorOptions]="{ items: dropdownUserProfiles, searchEnabled: true, displayExpr: displayUserProfileInDropdown, valueExpr:'id' }" [label]="{ text: 'Operator' }"></dxi-item>
				</dxo-form>
				</dxo-editing>
				<dxo-toolbar>
					<dxi-item name="addRowButton" showText="always"></dxi-item>
				</dxo-toolbar>
				<dxi-column dataField="operatorId" dataType="number" alignment="left" caption="Operator">
					<dxo-lookup [dataSource]="userProfiles" [displayExpr]="displayUserProfileInDropdown" valueExpr="id"></dxo-lookup>
				</dxi-column>
				<dxi-column type="buttons">
					<dxi-button name="edit"></dxi-button>
					<dxi-button name="delete"></dxi-button>
				</dxi-column>
			</dx-data-grid>
		</dxi-item>
	</dx-form>
	<dx-form *ngIf="popupTitle === 'Change Production Status'" class="m-3"
		[(formData)]="popupChangeMachineProductionStatus" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item dataField="productionStatus" editorType="dxSelectBox"
			[editorOptions]="{ items: productionStatuses, searchEnabled: true, displayExpr:'name', valueExpr:'id' }"
			[label]="{ text: 'Production Status' }"></dxi-item>
	</dx-form>
</dx-popup>